export default {
	default: {},
	validator() {}
};
